<div class="navbar-brand header-logo custom-logo">
  <a [routerLink]="['/admin/dashboard']" class="b-brand">
    <div class="logoImage">
      <img src="assets/images/indiapost.png" alt="isu">
    </div>
    <span class="b-title">India Post</span>
  </a>
  <a href="javascript:" class="mobile-menu" [ngClass]="{'on' : navCollapsed}" id="mobile-collapse" (click)="navCollapse()"><span></span></a>
</div>
